import { render } from "./ItineraryCard.vue?vue&type=template&id=639f4913&scoped=true"
import script from "./ItineraryCard.vue?vue&type=script&lang=js"
export * from "./ItineraryCard.vue?vue&type=script&lang=js"

import "./ItineraryCard.vue?vue&type=style&index=0&id=639f4913&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639f4913"]])

export default __exports__